import { durations, reducedMotionCSS } from '../../utils/motion';

interface LoadingSkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  count?: number;
}

export function LoadingSkeleton({
  width = '100%',
  height = '20px',
  borderRadius = '4px',
  count = 1,
}: LoadingSkeletonProps): JSX.Element {
  const items = Array.from({ length: count }, (_, i) => i);

  return (
    <>
      {items.map((i) => (
        <div
          key={i}
          className="ds-skeleton"
          role="presentation"
          aria-hidden="true"
          style={{
            width: typeof width === 'number' ? `${width}px` : width,
            height: typeof height === 'number' ? `${height}px` : height,
            borderRadius,
            background: 'linear-gradient(90deg, #eceef0 25%, #c4c6cf 50%, #eceef0 75%)',
            backgroundSize: '200% 100%',
            animation: `ds-skeleton-shimmer ${durations.shimmer} ease-in-out infinite`,
          }}
        />
      ))}

      <style>{`${reducedMotionCSS('.ds-skeleton')}`}</style>
    </>
  );
}
